import { render } from "./database_form.vue?vue&type=template&id=01611d05"
import script from "./database_form.vue?vue&type=script&lang=js"
export * from "./database_form.vue?vue&type=script&lang=js"
script.render = render

export default script